<template>
  <div class="lb">
    <div id="world-map" class="mapMian" ref="mapMian"></div>
    <div class="miaobian">
      <img class="mapImg" src="../../assets/temimg6/miaobian.png" alt />
    </div>
    <div class="map_nanhai">
      <img src="../../assets/temimg6/nanhai_map.png" alt />
    </div>
    <div class="legend">
      <div class="legend_left">
        <p>【图例说明】</p>
        <div><img src="../../assets/temimg6/point_icon.png" alt />园区</div>
      </div>
    </div>

    <!-- 新增的弹出窗口   popupData -->
    <div
      v-if="showPopup"
      class="popup"
      :style="{ top: popupTop + 'px', left: popupLeft + 'px' }"
    >
      <div class="dialog_main">
        <p class="title" :title="popupData.list[0].value2">{{ popupData.list[0].value2 }}</p>
      </div>
      <div class="dialog_item" v-for="(item, i) in popupData.list" :key="i">
        <div class="dialog_box">
          <div>
            <p class="dialog_text" :title="item.value3">
              {{ item.value3 }}
            </p>
            <p :title="item.value4" v-if="item.value4">
              ({{ item.value4 }})
            </p>
          </div>
          <span class="dialog_right">{{ numformat(item.value5) }}</span>
        </div>
      </div>
      <div class="dialog_bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import chinaJson from "./china.json";
import * as method from '@/components/scope/method.js'
export default {
  name: "template.scope1.center3",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "中国地图示例",
      timer2: null,
      autoTimePaused: false,
      defaultdata: [
        {
          value1: "北京市",
          value2: "北京金蝶软件园",
          value3: "建筑平方",
          value4: "平方米",
          value5: "255",
        },
        {
          value1: "安徽省",
          value2: "安徽金蝶软件园",
          value3: "建筑平方",
          value4: "平方米",
          value5: "332",
        },
        {
          value1: "河南省",
          value2: "河南金蝶软件园",
          value3: "建筑平方",
          value4: "平方米",
          value5: "125",
        },
        {
          value1: "北京市",
          value2: "北京金蝶软件园",
          value3: "建筑平方2233",
          value4: "平方米",
          value5: "255",
        },
      ],
      valueMap: [
        { name: "地区", key: "value1" },
        { name: "名称", key: "value2" },
        { name: "数据", key: "value3" },
        { name: "额外标注", key: "value4" },
        { name: "数值", key: "value5" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      config: {},
      showPopup: false, // 控制弹出窗口的显示和隐藏
      popupData: null, // 存储要显示的数据
      popupTop: 0, // 弹窗的 top 位置
      popupLeft: 0, // 弹窗的 left 位置
      currentIndex: 0, // 当前轮播数据的索引
      targetName: "", // 要高亮显示的名称
      defaultSymbol:
        "image://" + require("../../assets/temimg6/point_icon.png"),
      activeSymbol:
        "image://" + require("../../assets/temimg6/point_icon_red.png"), // 替换为你想要的激活状态图片路径
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
        this.DrawEcharts();
        // 如果有数据变化，可以在这里处理数据并更新地图
      }
    },
    jsondata(n) {
      this.exceldata = n;
      // 如果有数据变化，可以在这里处理数据并更新地图
    },
  },
  beforeDestroy() {
    const TmyChart = echarts.init(this.$refs.mapMian);
    TmyChart.clear();
    clearInterval(this.timer2);
    this.timer2 = null;
  },
  methods: {
    ...method,
    DrawEcharts() {
      clearInterval(this.timer2);
      this.timer2 = null;
      const echarts = require("echarts");
      const TmyChart = echarts.init(this.$refs.mapMian);
      let chartmap = [...new Set(this.defaultdata.map((item) => item.value1))]
      let chartmap2 = [...new Set(this.defaultdata.map((item) => item.value2))].filter(item => item)
      let chartdata = chartmap2.map(item => {
        let vname = this.defaultdata.find(del => del.value2 == item)
        let newitem = {
          name: vname.value1,
          list: []
        }
        this.defaultdata.forEach(del => {
          if (del.value2 == item) {
            newitem.list.push(del)
          }
        })
        return newitem
      })
      const Toption = {
        width: 920,
        height: 940,
        geo: [
          {
            map: "china",
            aspectScale: 1,
            zoom: 1,
            top: "6%",
            left: "2%",
            roam: false,
            regions: [
              {
                name: "南海诸岛",
                itemStyle: {
                  normal: {
                    opacity: 0,
                  },
                },
                label: {
                  show: false,
                },
              },
            ],
            tooltip: {
              show: false,
              // color: "transparent",
            },
            label: {
              show: false,
              emphasis: {
                show: false,
                color: "transparent",
              },
            },
            itemStyle: {
              normal: {
                areaColor: "transparent",
                borderColor: "transparent",
              },
              emphasis: {
                areaColor: "transparent",
              },
            },
          },
        ],
        series: [
          {
            type: "map",
            map: "china",
            zoom: 1,
            top: "6%",
            left: "2%",
            roam: false,
            selectedMode: false,
            label: {
              show: true,
              color: "#FFF",
              fontSize: 14,
              formatter: function (params) {
                if (params.name === "南海诸岛") {
                  return "";
                }
              },
              emphasis: {
                color: "#FFF",
                fontSize: 14,
              },
            },
            itemStyle: {
              normal: {
                areaColor: "transparent",
                borderColor: "transparent",
              },
              emphasis: {
                areaColor: "transparent",
              },
            },
            zlevel: 5,
            data: this.defaultdata.map((item) => ({
              name: item.value1,
              value: item.value2,
            })),
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            data: chinaJson.features
              .filter((item) => {
                return chartmap.some(
                  (defaultItem) => defaultItem === item.properties.name
                );
              })
              .map((item) => ({
                name: item.properties.name,
                value: item.properties.centroid,
              })),
            // symbolKeepAspect: true,
            // effectType: "none",
            // symbol: this.defaultdata.some(item => item.value1 == this.targetName) ? this.activeSymbol : this.defaultSymbol, // 设置图片路径,
            symbol: this.defaultSymbol, // 设置图片路径
            symbolSize: [50, 80], // 设置图片大小
            rippleEffect: {
              number: 1,
              scale: 1,
              // period:5,
              color: "transparent",
              show: false, // 关闭涟漪特效
            },
            label: {
              show: false,
            },
            itemStyle: {
              color: "transparent",
            },
            zlevel: 6,
          },
        ],
      };

      echarts.registerMap("china", chinaJson);
      Toption && TmyChart.setOption(Toption);
      this.timer2 = setInterval(() => {
        if (this.currentIndex >= chartdata.length) {
          this.currentIndex = 0;
        }
        const targetData = chartdata[this.currentIndex];

        if (targetData) {
          this.showPopup = true;
          this.popupData = targetData;

          this.targetName = targetData.name;
          const targetPoint = chinaJson.features.find(
            (item) => item.properties.name === this.targetName
          );

          if (targetPoint) {
            const point = targetPoint.properties.centroid;
            const pointInPixel = TmyChart.convertToPixel("geo", point);
            this.popupLeft = pointInPixel[0] + 10;
            this.popupTop = pointInPixel[1] - 10;

            // 更新 series 数据中的 symbol
            const seriesData = TmyChart.getOption().series[1].data;
            seriesData.forEach((dataItem) => {
              dataItem.symbol =
                dataItem.name === this.targetName
                  ? this.activeSymbol
                  : this.defaultSymbol;
            });
            // 重新设置 echarts 实例的选项
            TmyChart.setOption({
              series: [
                ...TmyChart.getOption().series.slice(0, 1),
                {
                  type: "effectScatter",
                  data: seriesData,
                },
              ],
            });
          } else {
            this.showPopup = false;
          }
        } else {
          this.showPopup = false;
        }

        this.currentIndex++;
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData()
    this.DrawEcharts();
  },
};
</script>

<style scoped lang="scss">
.lb {
  width: 972px;
  height: 972px;
  position: relative;
  z-index: 5;
  padding: 10px 0;
  margin-left: -25px;
  pointer-events: auto;
}
.mapMian {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 20;
}
.miaobian {
  width: 972px;
  height: 972px;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 2;
}

.map_nanhai {
  position: absolute;
  right: 10%;
  bottom: 16%;
  z-index: 10;
  width: 98px;
  height: 138px;
  img {
    width: 100%;
    height: 100%;
  }
}
.legend {
  position: absolute;
  bottom: 10%;
  left: 6%;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 30px;

  img {
    width: 39px;
    height: 55px;
  }
}
.mapImg {
  width: 1920px;
  height: 1080px;
  position: absolute;
  top: -14%;
  left: -48.8%;
  z-index: 3;
}
.mapline {
  width: 790px;
  height: 586px;
  position: absolute;
  top: 8%;
  left: 9%;
  z-index: 4;
}
.popup {
  width: 202px;
  position: absolute;
  // background: url("../../assets/temimg6/Dialog.png") no-repeat;
  // background-size: 100% 100%;
  color: white;
  /* padding: 10px; */
  /* border-radius: 5px; */
  z-index: 55;

  .dialog_main {
    width: 100%;
    height: 29px;
    background: url(@/assets/temimg6/log-top.png) no-repeat;
    background-size: 100% 100%;
    .title {
      width: 110px;
      margin-left: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      font-family: pmzd;
      font-weight: 400;
      font-size: 14px;
      line-height: 29px;
      color: #f0f0f0;
      cursor: pointer;
    }
  }

  .dialog_item {
    margin-top: -1px;
    padding: 10px 0 0 9px;
    height: 27px;
    box-sizing: border-box;
    width: 100%;
    background: url(@/assets/temimg6/log-center.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
  }
  .dialog_box {
    cursor: pointer;
    width: 180px;
    padding: 4px;
    box-sizing: border-box;
    background: #103B63;
    // border: #68c2f9 1px solid;
    overflow: hidden;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #e1f1ff;
    line-height: 12px;
    font-family: Hei;
    font-weight: 400;
    font-size: 12px;
    div {
      display: flex;
    }
    p {
      max-width: 100px;
      // width: 60px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p:nth-child(2) {
      margin-left: 4px;
      max-width: 60px;
      // width: 40px;
    }
    // .dialog_text {

    // }
    .dialog_right {
      text-align: right;
      margin-left: 10px;
      display: block;
      text-align: right;
      font-family: BenmoZiyu;
      font-weight: 400;
      font-size: 14px;
      color: #68c2f9;
    }
  }
  .dialog_bottom {
    width: 100%;
    height: 14px;
    background: url(@/assets/temimg6/log-bottom.png) no-repeat;
    background-size: 100% 100%;
    margin-top: -1px;
  }
}
</style>
